
import { Icon, InlineIcon } from "@iconify/vue";
import flagIcon from "@iconify-icons/dashicons/flag";
import { defineComponent } from "vue";
import Toggle from "@/components/Toggle.vue";

import isEqual from "lodash/fp/isEqual";
import {
  Environment,
  Feature,
  VexillaFeature,
  VexillaFeatureTypeString,
} from "@/store/app";
import { mapState } from "vuex";

export default defineComponent({
  name: "Feature",
  data() {
    return {
      type: "toggle",
    };
  },
  methods: {
    randomizeSeed(environment: Environment) {
      const randomValue = Math.floor(Math.random() * 100);
      this.handleSeedChange(environment, randomValue);
    },
    getFeatureSettings(environment: Environment) {
      return this.$store.getters["app/getFeatureSettings"](
        this.feature,
        environment,
        this.type
      );
    },
    handleToggleChange(environment: Environment, toggled: boolean) {
      console.log("inside handle toggle change", toggled);
      this.$store.dispatch("app/setFeatureSettings", {
        feature: this.feature,
        environment,
        type: this.type,
        settings: {
          value: toggled,
        } as VexillaFeature,
      });
    },
    setToggle(environment: Environment, toggled: boolean) {
      this.$store.dispatch("app/setFeatureSettings", {
        feature: this.feature,
        environment,
        type: this.type,
        settings: {
          value: toggled,
        } as VexillaFeature,
      });
    },
    handleSeedChange(environment: Environment, value: number) {
      this.$store.dispatch("app/setFeatureSettings", {
        feature: this.feature,
        environment,
        type: this.type,
        settings: {
          seed: +value / 100,
        } as VexillaFeature,
      });
    },
    handleThresholdChange(environment: Environment, value: number) {
      this.$store.dispatch("app/setFeatureSettings", {
        feature: this.feature,
        environment,
        type: this.type,
        settings: {
          value: +value,
        } as VexillaFeature,
      });
    },
    updateType(type: string) {
      this.$store.dispatch("app/editFeature", {
        previous: this.feature,
        current: {
          ...this.feature,
          type,
        },
      });
    },
  },
  created() {
    if (!this.feature) {
      this.$router.replace("/");
      this.type = this.feature?.type;
    } else {
      this.type = this.feature?.type;
    }
  },
  updated() {
    this.type = this.feature?.type;
  },
  activated() {
    this.type = this.feature?.type;
  },
  computed: {
    ...mapState("app", ["environments", "featureSettings"]),
    feature() {
      return this.$store.getters["app/featureByName"](this.$route.params.name);
    },
  },
  watch: {
    feature(feature: Feature, oldFeature: Feature) {
      this.type = feature?.type;
    },
    type(type, oldType) {
      this.updateType(type);
    },
  },
  components: {
    Toggle,
  },
});
